import immerHandleActions from 'redux/utils/immerHandleActions';

import { hideNotification } from './actions';

const init = () => ({
	cookiesAccepted: false,
});

const reducer = {
	[hideNotification](state: any) {
		return { ...state, cookiesAccepted: true };
	},
	'persist/REHYDRATE'(state: any, { payload = {} }) {
		// @ts-ignore
		return { ...state, ...payload.settings?.cookies };
	},
};

export default immerHandleActions(reducer, init());
